import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
    // For now, we check the localStorage to simulate a highly secure JWT auth check.
    // In production, this would be validated by Context or an API ping.
    const isAuthenticated = localStorage.getItem('adminToken');
    
    // If not authenticated, redirect directly to the login page
    if (!isAuthenticated) {
        return <Navigate to="/admin-login" replace />;
    }
    
    // If authenticated, render the child component (e.g. The Admin Gallery)
    return children;
};

export default ProtectedRoute;
